import { useState, useEffect } from 'react';

export const useCounters = (isLoading: boolean) => {
  const [counters, setCounters] = useState({ projects: 0, satisfaction: 0, years: 0, support: 0 });

  useEffect(() => {
    const animateCounters = () => {
      const targets = { projects: 150, satisfaction: 98, years: 5, support: 24 };
      const duration = 2000;
      const steps = 60;
      const stepDuration = duration / steps;

      let step = 0;
      const timer = setInterval(() => {
        step++;
        const progress = step / steps;
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);

        setCounters({
          projects: Math.floor(targets.projects * easeOutQuart),
          satisfaction: Math.floor(targets.satisfaction * easeOutQuart),
          years: Math.floor(targets.years * easeOutQuart),
          support: Math.floor(targets.support * easeOutQuart)
        });

        if (step >= steps) {
          clearInterval(timer);
          setCounters(targets);
        }
      }, stepDuration);

      return () => clearInterval(timer);
    };

    // Start animation after loading
    if (!isLoading) {
      const timer = setTimeout(animateCounters, 1000);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  return counters;
};
